module.exports = __webpack_public_path__ + "img/lottesuper.b783ff55.png";